import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SOFTLINE_API_DOCUMENT_QUERY_TYPES } from '../sales.api';
import { DocumentType } from '../types/document-type';

@Injectable()
export class DocumentTypeRepository extends ReadonlyHttpApiCollectionRepository<
  DocumentType[]
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_DOCUMENT_QUERY_TYPES);
  }

  // TODO: move to the sales-document-service, scoped to the customer —
  // GET /sales-document-service/.../document-types?customerId={id}
  // (SOFTLINE_API_SALES_DOCUMENT_TYPES). Wire the id through the service params
  // from the document's customer (SalesDocument.customer.id) or the picked
  // customer (MasterdataCustomer.id).
}
